import { Component } from '@angular/core';
import { WellData, FieldData } from '../../../app/_models/field';
import { PortalApiService } from '../../../app/_services/portal-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserProfile } from '../../_models/user-profile';
import { UserProfileService } from '../../_services/user-profile.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-well-files',
  templateUrl: './well-files.component.html',
  styleUrls: ['./well-files.component.css']
})
export class WellFilesComponent {
  selectedWellID: any = null;
  selectedWell: WellData;
  hasWellFilesAccess: boolean = true;
  userProfile: UserProfile = new UserProfile;
  fieldListWithWells: FieldData[];
  errorSelectedWell: string;
  wellsList: WellData[];
  wellOptions: any[] = [];
  isLoadingWellList: boolean;
  errorWellList: string = null;
  private onDestroy$ = new Subject<void>();

  constructor(
    private apiService: PortalApiService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserProfileService,
    private titleService: Title
  ) {
    this.userService.userProfile$.pipe(takeUntil(this.onDestroy$)).subscribe(currentProfile => {
      this.userProfile = currentProfile;
      this.checkForWellFilesPermission();
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.selectedWellID = +params['wellId'];
    })
    this.getFieldAndWellList();
    this.titleService.setTitle('Well Files - Productioneer Portal');
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  checkForWellFilesPermission() {
    if (this.userProfile.permissions.includes('WELLFILES') || this.userProfile.isSuperAdmin) {
      this.hasWellFilesAccess = true;
    }
    else {
      this.hasWellFilesAccess = false;
    }
  }

  getFieldAndWellList() {
    this.errorWellList = null;
    this.fieldListWithWells = [];
    this.wellsList = [];
    this.isLoadingWellList = true;
    this.apiService.getFieldList(true).subscribe({
      next: (data: FieldData[]) => {
        let lstWellOptions: any[] = [];
        this.fieldListWithWells = data;
        for (var i = 0; i < this.fieldListWithWells.length; i++) {
          for (var j = 0; j < this.fieldListWithWells[i].wells.length; j++) {
            let wellLabel: string = this.fieldListWithWells[i].wells[j].wellName + ' - API#' + this.fieldListWithWells[i].wells[j].apiNumber;
            let newSelectOption: any = {
              wellName: this.fieldListWithWells[i].wells[j].wellName,
              apiNumber: this.fieldListWithWells[i].wells[j].apiNumber,
              label: wellLabel,
              value: this.fieldListWithWells[i].wells[j].wellID
            }
            this.fieldListWithWells[i].wells[j].fieldName = this.fieldListWithWells[i].fieldName;
            this.wellsList.push(this.fieldListWithWells[i].wells[j]);
            lstWellOptions.push(newSelectOption);
          }
        }

        this.wellOptions = lstWellOptions;
        if (this.selectedWellID != null) {
          this.selectedWellChanged();
        }
        this.isLoadingWellList = false;
      },
      error: err => {
        console.log(err);
        this.errorWellList = (err.error || 'An error occurred while retrieving the well list.');
        this.isLoadingWellList = false;
      }
    })
  }

  onWellSelect(value: any) {
    this.selectedWellChanged();
    this.router.navigate(['../../wellfiles/' + this.selectedWellID], { relativeTo: this.route });
  }

  selectedWellChanged() {
    let foundWell: WellData = this.wellsList.find(well => well.wellID == this.selectedWellID);
    if (foundWell && foundWell != null) {
      this.selectedWell = foundWell;
    }
    else {
      this.selectedWellID = null;
      this.selectedWell = null;
      this.errorSelectedWell = 'An error occurred. The requested well could not be found.';
    }
  }
}
